import script from "./DashboardItemLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardItemLoader.vue?vue&type=script&setup=true&lang=js"

import "./DashboardItemLoader.vue?vue&type=style&index=0&id=4d3014ec&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d3014ec"]])

export default __exports__